const meta = {
  'version-equivalents': 'Version equivalents',
  'docker-install': 'Install in Docker',
  'linux-debian-install': 'Install on Linux (Debian-based)',
  'linux-rhel-install': 'Install on Linux (RHEL-based)',
  'macos-install': 'Install on macOS',
  'windows-install': 'Install on Windows',
};

export default meta;
